var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pot-1-map",attrs:{"id":"pot-1-map"}})
}
var staticRenderFns = []

export { render, staticRenderFns }